// extracted by mini-css-extract-plugin
export default {"wrap":"s_wrap__KHaMM","inner":"s_inner__l7osF","header":"s_header__6r+iL","closeButton":"s_closeButton__yslkB"};